import systemconfigsReducer from "./reducers";
export { default as systemconfigsTypes } from "./types";
export { default as systemconfigsOperations } from "./operations";
export default systemconfigsReducer;
